import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EsignatureRecipientListStore } from "../../store/EsignatureRecipientListStore";

type EsignatureRecipientListDialogsProps = {
  store: EsignatureRecipientListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EsignatureRecipient.
 * Separado para mantener EsignatureRecipientListPage más limpio.
 */
export const EsignatureRecipientListDialogs: React.FC<EsignatureRecipientListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
